import React from 'react';
import { NavLink } from 'react-router-dom';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import iconofficialflagUrl from '../images/usFlag.png';
import dhslogoUrl from '../images/dhs_logo.png';
import dhslogowhiteUrl from '../images/CBPlogoWhite.png'
import fincenlogoUrl from '../images/FINCEN_logo.png';
import headerflagUrl from '../images/US_flag_3.jpg';
import eCMIRLogoUrl from '../images/eCMIRBannerLogo.png';

function Header() {
  const cmirHeaderSx = {
    display: 'flex',
    width: '100%',
    height:	'140px',
    background: 'transparent',
    flexWrap: 'wrap',
    backgroundColor: '#1c3764', 
    backgroundImage: `url(${headerflagUrl})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "-440px 28px",
		backgroundSize: "auto",
  };

  const dhsSealSx = {
    borderWidth: '0px',
    margin: '10px',
    paddingLeft: { xs: '16px', sm: '30px' },
    content: {
      xs: `url(${dhslogoUrl})`,
      sm: `url(${dhslogoUrl})`,
      md: `url(${dhslogowhiteUrl})`,
    },
    height: {
      xs: '60px',
      sm: '75px',
      md: '65px',
      lg: '75px',
    },
  };

  const fincenSealSx = {
    borderWidth: '0px',
    width: { xs: '60px', sm: '75px' },
    height: { xs: '60px', sm: '75px' },
    margin: '10px',
    paddingLeft: '10px',
  };

  const usofficialSx = {
    color: '#fff',
    fontSize: '0.9em',    
    background: '#323232',    
    height:		    '28px',
    width: '100%',
  };

  const usofficialimgSx = {
    width: '22px',
    paddingLeft: '24px',
  };

  const usofficialspanSx = {
    paddingLeft: '10px',
    fontFamily: 'Georgia',
    fontSize: '12px'
  };

  const cbptextSx = {
    color: '#ffffff00',
    borderRight: '1px solid white',
    display: 'block',
    fontWeight: '600',
    fontFamily: 'Times New Roman, Times, serif',    
    fontSize: { xs: '0px', sm: '12px', md: '16px', lg: '18px' },
  };

  const tresuryText1Sx = {
    color: '#FFFFFF',
    marginLeft: '7px',
    fontSize: { xs: '0px', sm: '0px', md: '16px', lg: '22px' },
  };

  const tresuryText2Sx = {
    color: '#FFFFFF',
    marginLeft: '7px',
    fontSize: { xs: '0px', sm: '0px', md: '14px', lg: '16px' },
  };

  const marginTopSx = {
    marginTop: '25px'
  };

  const ecmirlogoSx = {
    marginRight: { xs: 1.5, sm: 3.5 },
    marginTop: 0.6,
    cursor: 'pointer',
    height: { xs: "58px", sm: "68px", md: "78px" },
    width: { xs: "132px", sm: "188px", md: "220px" },
  };

  return ( 
    <Box sx={{ flexGrow: 1 }}>
      <Grid container columnSpacing={1} sx={cmirHeaderSx}>
        <Grid xs={8} sx={usofficialSx}>
          <Box component="img" sx={usofficialimgSx} id="usflag" src={iconofficialflagUrl} alt="US Flag"/>
          <Box component="span" sx={usofficialspanSx}>Official Website of the Department of Homeland Security</Box>
        </Grid>
        <Grid xs="auto">
            <a href="https://www.cbp.gov" target="_blank" rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
                     <Box component="img" sx={dhsSealSx} id="dhslogo" src={dhslogowhiteUrl}
                     title="Official Seal of the U.S. Customs and Border Protection, U.S. Department of Homeland Security" alt="DHS Logo"/>             
            </a>
        </Grid>
        <Grid sx={{ ...marginTopSx, justifyContent: 'flex-start' }}>
            <Typography sx={cbptextSx}>|</Typography>
            <Typography sx={cbptextSx}>|</Typography>
        </Grid>
        <Grid xs="auto">
            <a href="https://www.fincen.gov/" target="_blank" rel='noopener noreferrer' style={{ textDecoration: 'none' }}>              
                   <Box component="img" sx={fincenSealSx} id="fincenlogo" src={fincenlogoUrl} 
                   title="Financial Crimes Enforcement Network, U.S. Department of the Treasury" alt="FINCEN Logo"/>
                   </a>
        </Grid>
        <Grid xs="auto" sx={marginTopSx} >
            <Typography sx={tresuryText1Sx}>U.S. Treasury</Typography>
            <Typography sx={tresuryText2Sx}>Financial Crimes Enforcement Network</Typography>
        </Grid>
        <Grid sx={{ flexGrow: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end' }}>
            <NavLink to="/" rel='noopener noreferrer' style={{ textDecoration: 'none' }}>
                <Box component="img" sx={ecmirlogoSx} id="ecmirlogo" title="FinCEN Form 105" src={eCMIRLogoUrl} alt="eCMIR Logo"/>
            </NavLink>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Header;
